const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135.26583 101.44937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "68.8954 65.93991 12.28877 65.93991 12.28877 14.88367 114.71301 14.88367",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.71301,
    y1: 65.93991,
    x2: 79.8483,
    y2: 65.93991,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.89773,
    y1: 27.47109,
    x2: 106.89773,
    y2: 52.37753,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.35605,89.73773l-6.59272-8.70106,5.92004-1.16798c.89411-.17627,1.21642-1.30274.52954-1.9237l-23.9577-21.52085c-.77829-.704-2.02598-.02112-1.84175,1.02085l5.47099,31.36294c.15114.88792,1.25139,1.23063,1.88618.59656l4.73786-4.7455,5.91786,10.39422c.33142.57653,1.06637.72803,1.59191.37257l6.0727-4.09104c.5324-.35728.6504-1.09041.26508-1.59701Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21.49425 33.64171 26.55406 47.18187 31.53593 33.64171 36.59652 47.18187 41.57797 33.64171",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.98814 33.64171 52.04794 47.18187 57.02981 33.64171 62.09041 47.18187 67.07185 33.64171",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "72.48202 33.64171 77.54183 47.18187 82.5237 33.64171 87.58429 47.18187 92.56574 33.64171",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.20372,
    y1: 47.16731,
    x2: 96.20372,
    y2: 47.16731,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.4f0dfe7861f991a830ac8c6182ca8453.svg";
export { ForwardRef as ReactComponent };